import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import Checkbox from '~/ui/components/inputs/Checkbox';
import DatePicker from '~/ui/components/inputs/DatePicker';
import Input from '~/ui/components/inputs/Input';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';

import type { WorkDetailsSectionProps } from '../types';

import styles from '../Form.module.scss';

const WorkDetailsSection = ({
  options,
  control,
  register,
  errors,
  clinicHasCrisisTeam,
  showCrisisCheckbox,
}: WorkDetailsSectionProps) => (
  <Paper>
    <Box sx={{ p: 2 }}>
      <p className={styles.formTitle}>Work Details</p>
      <Grid container spacing={2}>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <Select
            options={options.credentials}
            control={control}
            errors={errors}
            name="workDetails.credentialsId"
            label="Credentials"
            hideSelectedOptions={false}
            openMenuOnFocus
          />
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <Select
            options={options.employmentStatuses}
            control={control}
            errors={errors}
            name="workDetails.employmentStatusId"
            label="Employment Status"
            hideSelectedOptions={false}
            openMenuOnFocus
          />
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <Select
            options={options.educations}
            control={control}
            errors={errors}
            name="workDetails.educationId"
            label="Education"
            hideSelectedOptions={false}
            openMenuOnFocus
          />
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <Input
            type="number"
            register={register}
            errors={errors}
            name="workDetails.experience"
            label="Years of Experience"
          />
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <DatePicker
            openTo="date"
            control={control}
            errors={errors}
            label="Hire Date"
            name="workDetails.hireDate"
          />
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <Input register={register} errors={errors} name="emrId" label="EMR ID" />
        </Grid>
        {clinicHasCrisisTeam && showCrisisCheckbox && (
          <Grid
            size={{
              sm: 6,
            }}
          >
            <Checkbox
              control={control}
              errors={errors}
              name="crisisAccess"
              label="Access to Crisis Map"
            />
          </Grid>
        )}
      </Grid>
    </Box>
  </Paper>
);

export default WorkDetailsSection;
